import { partnerPurchaseOrderConfigurationSchema } from './partner-purchase-order-configuration.schema';
import { partnerIntegrationCredentialsSchema } from './partner-integration-credentials.schema';
import { eldPartnerTypeSchema } from './eld-partner-type.schema';
import { accountProductSchema } from './account-product.schema';
import { webApplicationSchema } from './web-application.schema';
import { companyTypeSchema } from '../../../schemas/company-type.schema';
import { z } from 'zod/v4';

export const accountSummarySchema = z.object({
  companyName: z.string(),
  companyCode: z.string(),
  companyType: companyTypeSchema,
  eldPartnerType: eldPartnerTypeSchema.nullable(),
  externalAccountId: z.string(),
  partnerEmail: z.string().nullable(),
  partnerId: z.string().nullable(),
  partnerIntegrationCredentials: z.array(partnerIntegrationCredentialsSchema),
  partnerName: z.string().nullable(),
  partnerPhone: z.string().nullable(),
  partnerPurchaseOrderConfiguration: partnerPurchaseOrderConfigurationSchema,
  products: z.array(accountProductSchema),
  webProducts: z.array(webApplicationSchema),
});

export type AccountSummary = z.infer<typeof accountSummarySchema>;
